import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  originalTutorials: [],
  tutorials: [],
  tab: "all",
  searchQuery: "",
  selectedTutorial: null,
};

const tutorialsSlice = createSlice({
  name: "tutorials",
  initialState,
  reducers: {
    setTutorials: (state, action) => {
      state.originalTutorials = Array.isArray(action.payload) ? action.payload : [];
      state.tutorials = Array.isArray(action.payload) ? action.payload : [];
    },
    // Change tab and filter list
    setTab: (state, action) => {
      state.tab = action.payload;
      state.tutorials = state.originalTutorials.filter((t) => 
        state.tab === "all" ? true : t.status === state.tab
      ).filter((t) => 
        state.searchQuery ? t.title.toLowerCase().includes(state.searchQuery.toLowerCase()) : true
      );
    },

    // Update search query and filter list
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
      state.tutorials = state.originalTutorials.filter((t) => 
        state.tab === "all" ? true : t.status === state.tab
      ).filter((t) => 
        state.searchQuery ? t.title.toLowerCase().includes(state.searchQuery.toLowerCase()) : true
      );
    },

    // Select tutorial by ID
    setSelectedTutorial: (state, action) => {
      state.selectedTutorial = state.tutorials.find(
        (t) => t.id === action.payload
      );
    },

    // Mark tutorial as "complete"
    completeTutorial: (state) => {
      if (state.selectedTutorial) {
        state.selectedTutorial.status = "complete";

        // Update original list
        state.originalTutorials = state.originalTutorials.map((t) =>
          t.id === state.selectedTutorial.id ? { ...t, status: "complete" } : t
        );

        // Reapply filters
        state.tutorials = state.originalTutorials.filter((t) => 
          state.tab === "all" ? true : t.status === state.tab
        ).filter((t) => 
          state.searchQuery ? t.title.toLowerCase().includes(state.searchQuery.toLowerCase()) : true
        );
      }
    },
  },
});

export const {
  setTab,
  setSearchQuery,
  setSelectedTutorial,
  completeTutorial,
  setTutorials,
} = tutorialsSlice.actions;

export default tutorialsSlice.reducer;